import React, { FunctionComponent } from 'react';
import './loader.css';

const Spinner: FunctionComponent = () => (
  <div className="lds-ripple">
    <div />
    <div />
  </div>
);

export default Spinner;
